export default "__VITE_ASSET__Cfo90SU4__"